module.exports = __webpack_public_path__ + "static/media/agenda.b73853e7.png";